"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CapabilityReview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const zones = [{
    key: "eyebrow",
    content: <p className="text-sm font-medium tracking-wider uppercase text-ink-secondary font-default">
          Authentic Capability Development
        </p>
  }, {
    key: "headline",
    content: <h2 className="mt-6 font-serif text-4xl md:text-5xl lg:text-6xl font-normal leading-[1.06] tracking-tight text-ink-primary">
          Skills. Development. Affinity. —{" "}
          <span className="italic font-normal text-accent-sky">Human Connection</span>{" "}
          through Real Impact.
        </h2>
  }, {
    key: "lead",
    content: <p className="mt-8 mx-auto max-w-[580px] text-lg md:text-xl leading-[1.65] text-ink-secondary font-default">
          We transform organizational gaps into tangible results. By delivering real-world projects, we foster authentic capability growth and create direct pathways for emerging talent to make a measurable difference.
        </p>
  }, {
    key: "buttons",
    content: <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
          <Button asChild className="h-[52px] rounded-lg px-8 bg-accent-sky text-white hover:bg-accent-sky/90 transition-all duration-300 text-base font-medium font-default w-full sm:w-auto shadow-lg shadow-accent-sky/20">
            <Link to="/ContactPage">Discuss ESO</Link>
          </Button>
        </div>
  }];
  return;
}